import { createContext, useContext, useState, ReactNode, useEffect } from "react";
import "./loading.css";
import eventEmitter from "../../utils/eventEmitter";

interface LoadingContextType {
    isLoading: boolean;
    showLoading: () => void;
    hideLoading: () => void;
}

interface LoadingProviderProps {
    children: ReactNode;
}

const LoadingContext = createContext<LoadingContextType>({
    isLoading: false,
    showLoading: () => { },
    hideLoading: () => { },
});

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const handleShow = () => setIsLoading(true);
        const handleHide = () => setIsLoading(false);

        eventEmitter.on('showLoading', handleShow);
        eventEmitter.on('hideLoading', handleHide);

        return () => {
            eventEmitter.off('showLoading', handleShow);
            eventEmitter.off('hideLoading', handleHide);
        };
    }, []);

    return (
        <LoadingContext.Provider value={{ isLoading, showLoading: () => eventEmitter.emit('showLoading'), hideLoading: () => eventEmitter.emit('hideLoading') }}>
            {children}
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loader"></div>
                </div>
            )}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);
